<template>
  <div class="cookies" v-if="show">
    <div class="content">
      <img src="../assets/images/cookie.png" alt="">
      <div class="info-cookies">
        <p>{{ $t('qic_cookie_notice_header') }}</p>
        <span>{{ $t('qic_cookie_notice_description') }}</span>
      </div>
    </div>
    <button class="btnSecond" type="button" @click="onAccept()">{{ $t('qic_accept') }}</button>
  </div>
</template>

<script>
export default {
  name: 'CookieNotice',
  data () {
    return {
      show: false
    }
  },
  methods: {
    onAccept () {
      this.show = false
      localStorage.setItem('cookie_notice', 1)
    }
  },
  mounted () {
    this.show = !localStorage.getItem('cookie_notice')
  }
}
</script>
